'use client'

import { IINDUSTRY } from '@/utils/interface'
import Link from 'next/link'





export default function IndustryListPage({ data }: { data: IINDUSTRY[] }) {

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 transition-colors dark:bg-slate-950 dark:text-white">
      <section className="border-b border-slate-200 bg-gradient-to-br from-[#4373e0]/10 via-white to-slate-100 dark:border-white/10 dark:from-[#4373e0]/20 dark:via-slate-950 dark:to-slate-950">
        <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10">


          <div className="grid gap-10 lg:grid-cols-[1.2fr_0.8fr] lg:items-end">
            <div>
              <p className="mb-3 text-xs font-semibold uppercase tracking-[0.28em] text-[#4373e0] dark:text-[#7ba3ff]">
                Explore Industries
              </p>
              <h1 className="text-4xl font-bold tracking-tight text-slate-900 dark:text-white md:text-5xl">
                Discover industry
              </h1>
              <p className="mt-4 max-w-2xl text-base text-slate-600 dark:text-slate-300 md:text-lg">
                Browse a curated list of industries and open the corresponding company listing page for each one.
              </p>
            </div>

            {/* <div className="grid gap-4 sm:grid-cols-3">
              <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm dark:border-white/10 dark:bg-white/5">
                <div className="text-sm text-slate-600 dark:text-slate-300">Industries</div>
                <div className="mt-2 text-3xl font-bold text-[#4373e0] dark:text-[#8db0ff]">
                  {data?.length}
                </div>
              </div>

              <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm dark:border-white/10 dark:bg-white/5">
                <div className="text-sm text-slate-600 dark:text-slate-300">Companies</div>
                <div className="mt-2 text-3xl font-bold text-emerald-700 dark:text-emerald-300">
                  91
                </div>
              </div>

              <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm dark:border-white/10 dark:bg-white/5">
                <div className="text-sm text-slate-600 dark:text-slate-300">Searchable</div>
                <div className="mt-2 text-3xl font-bold text-amber-700 dark:text-amber-300">
                  Live
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      {/* <section className="mx-auto max-w-7xl px-6 py-8 lg:px-10">
        <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-lg shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900/70 dark:shadow-slate-950/30">
          <input
            type="text"
            value={search}
            defaultValue={query || ''}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search industry name or description..."
            className="w-full rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-900 outline-none placeholder:text-slate-400 focus:border-[#4373e0] dark:border-white/10 dark:bg-slate-950 dark:text-white dark:placeholder:text-slate-500"
          />
        </div>
      </section> */}

      <section className="mx-auto max-w-7xl px-6 pb-16 lg:px-10 mt-7">
        <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-3">
          {data?.map((industry) => (
            <article
              key={industry?._id}
              className="rounded-2xl border border-slate-200 bg-white p-5 shadow-lg shadow-slate-200/60 transition hover:-translate-y-1 dark:border-white/10 dark:bg-slate-900/80 dark:shadow-slate-950/20"
            >
              <div className="flex items-start justify-between gap-3">
                <div>
                  <h2 className="text-2xl font-semibold text-slate-900 dark:text-white">
                    {industry?.title}
                  </h2>
                  {/* <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">
                    {industries?.[0]?.description}
                  </p> */}
                </div>

                {/* {true && (
                  <span className="rounded-full bg-[#4373e0]/10 px-3 py-1 text-xs font-semibold text-[#4373e0] dark:bg-[#4373e0]/20 dark:text-[#8db0ff]">
                    Featured
                  </span>
                )} */}
              </div>

              <div className="mt-5 flex items-end justify-end">
                {/* <span className="rounded-full bg-[#4373e0]/10 px-3 py-1 text-xs font-medium text-[#4373e0] dark:bg-[#4373e0]/20 dark:text-[#8db0ff]">
                  {100} companies
                </span> */}

                <Link
                  href={industry?.slug ? `/industry/${industry.slug}` : "#"}
                  className="rounded-full bg-[#4373e0] px-4 py-2 text-xs font-semibold text-white transition hover:bg-[#315fc4] dark:bg-[#4373e0] dark:text-slate-950"
                >
                  View Companies   →
                </Link>
              </div>
            </article>
          ))}
        </div>

        {data?.length === 0 && (
          <div className="mt-6 rounded-2xl border border-slate-200 bg-white p-6 text-slate-600 dark:border-white/10 dark:bg-slate-900 dark:text-slate-300">
            No industries found for your search.
          </div>
        )}
      </section>
    </div>
  )
}